/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { banquetCartGroupModifierRequestSchema } from "./banquetCartGroupModifierRequestSchema.ts";
import { banquetCartModifierRequestSchema } from "./banquetCartModifierRequestSchema.ts";

export const banquetCartItemRequestSchema = z.object({
	id: z.uuid(),
	amount: z.int(),
	size: z.uuid().nullable(),
	comment: z.string().min(1).nullable(),
	modifiers: z.array(banquetCartModifierRequestSchema),
	group_modifiers: z.array(banquetCartGroupModifierRequestSchema),
});
